import { BookOpen } from "lucide-react";

export const EmptyState = () => {
  return (
    <div className="text-center py-16">
      <BookOpen className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
      <h3 className="text-xl font-semibold mb-2">Nenhum termo encontrado</h3>
      <p className="text-muted-foreground">
        Tente ajustar sua busca ou remover os filtros.
      </p>
    </div>
  );
};
